import React from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import {
  calculateRawDatasetSummary,
  resetSelectedParameterFilter
} from 'store';

const ParameterFilterComponent = props => {
  const dispatch = useDispatch();
  const onCrossClick = () => {
    dispatch(resetSelectedParameterFilter(props.name));

    dispatch(calculateRawDatasetSummary());
  };

  const getFilterOptions = () => {
    const { x, y } = props.filterOptions;

    switch (props.filterType) {
      case 'GT':
        return `Greater than ${x}`;
      case 'GTE':
        return `Greater than or Equal to ${x}`;
      case 'LT':
        return `Less than ${x}`;
      case 'LTE':
        return `Less than or Equal to ${x}`;
      case 'BTW':
        return `Between ${x} and ${y}`;
      case 'EQLNUM':
        return `Equal to ${x}`;
      case 'EQLCAT':
        return `Equal to ${x}`;
      case 'NEQL':
        return `Not Equal to ${x}`;
      default:
        return null;
    }
  };

  return (
    <span className="tooltip-dataset width-full">
      <i className="icon icon-cross cursor--pointer mr-5" onClick={onCrossClick} />
      {getFilterOptions()}
    </span>
  );
};

ParameterFilterComponent.propTypes = {
  name: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  filterOptions: PropTypes.object.isRequired
};

export default ParameterFilterComponent;
